/**
 * Utility function to process cell class styling for TableAdv component
 * Applies conditional styling to table cells based on row data and column configuration
 * @param {Object} row - The row data object
 * @param {Object} column - The column configuration object
 * @returns {string} CSS class names to apply to the cell
 */
const processCellClass = (row, column) => {
  if (!row || !column) return '';
  
  try {
    // Check if the column has a getCellClass function
    if (typeof column.getCellClass === 'function') {
      // Call the provided function with the row data
      const customClasses = column.getCellClass(row);
      
      // Return the custom classes if they exist
      return customClasses || '';
    }
    
    return '';
  } catch (error) {
    console.error('Error processing cell class:', error);
    return '';
  }
};

export default processCellClass;